import { render } from "./EmployeeResign.vue?vue&type=template&id=a4851ff8&scoped=true"
import script from "./EmployeeResign.vue?vue&type=script&lang=js"
export * from "./EmployeeResign.vue?vue&type=script&lang=js"

import "./EmployeeResign.vue?vue&type=style&index=0&id=a4851ff8&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4851ff8"]])

export default __exports__